import {useEffect} from 'react';
import {CRS, Icon} from 'leaflet';
import {ImageOverlay, MapContainer, Marker, Tooltip, useMap, ZoomControl} from 'react-leaflet';

const WIDTH = 3386;
const HEIGHT = 870;
const BOUNDS = [[0, 0], [HEIGHT, WIDTH]];
const icon = new Icon({iconUrl: '/static/img/eml-marker.png', iconSize: [54, 54]});

// Coordinates are original-image pixels, measured right/down from the top-left.
export function relativePosition(point) {
    if (!point || !Number.isFinite(point.x) || !Number.isFinite(point.y) ||
        point.x < 0 || point.x > WIDTH || point.y < 0 || point.y > HEIGHT) return null;
    return [HEIGHT - point.y, point.x];
}

function Viewport({locationMarker, showAllLocations, updateLocations}) {
    const map = useMap();
    useEffect(() => {
        map.fitBounds(BOUNDS);
        const observer = new ResizeObserver(() => {
            map.invalidateSize();
            map.fitBounds(BOUNDS);
        });
        observer.observe(map.getContainer());
        return () => observer.disconnect();
    }, [map]);
    useEffect(() => {
        const position = relativePosition(locationMarker);
        if (position && !showAllLocations) map.panTo(position, {animate: false});
    }, [map, locationMarker, showAllLocations, updateLocations]);
    return null;
}

export default function RelativeFloorPlan({locationMarker, allLocationMarkers = [], showAllLocations = false,
    updateLocations = true, onSelect, selectedCall}) {
    const markers = showAllLocations ? allLocationMarkers : [locationMarker];
    return <div className="relative flex-1" aria-label="SBM Ship floor plan">
        <MapContainer crs={CRS.Simple} bounds={BOUNDS} minZoom={-5} maxZoom={3}
            attributionControl={false} zoomControl={false} scrollWheelZoom={true}>
            <ImageOverlay url="/static/img/SBM.png" bounds={BOUNDS}/>
            <ZoomControl position="topright"/>
            <Viewport locationMarker={locationMarker} showAllLocations={showAllLocations} updateLocations={updateLocations}/>
            {markers.map((marker, index) => {
                const position = relativePosition(marker);
                return position ? <Marker key={marker.id ?? index} position={position} icon={icon}
                    opacity={selectedCall && marker.callUuid !== selectedCall ? 0.55 : 1}
                    eventHandlers={{click: () => onSelect?.(marker.callUuid)}}>
                    <Tooltip>{marker.timestampLabel ?? marker.id}</Tooltip>
                </Marker> : null;
            })}
        </MapContainer>
    </div>;
}
